/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { cardProviders } from '../../../../../screens/Card/constants';
import { useUserCardProvider } from '../../../../../utilities/sharedHooks/user';

const POSITIONS = {
  [cardProviders.MONAVATE]: {
    x: 128,
    y: 168,
    fontSize: 16,
  },
  [cardProviders.GALILEO]: {
    x: 125,
    y: 169,
    fontSize: 12,
  },
};
export function CVVValue({
  isShowSecretInfo = false,
  isLoadingCVC = false,
  cvc = '',
  onClick = () => {},
  cvcError = null,
}) {
  const { cardProvider } = useUserCardProvider();

  const {
    x = 135,
    y = 130,
    fontSize = 16,
    fontFamily = 'Open Sans',
  } = POSITIONS[cardProvider] || {};

  return (
    <g>
      {(!isShowSecretInfo || isLoadingCVC || cvcError || !cvc) && (
        <text
          className="cursor-pointer"
          fill="white"
          fontWeight="bold"
          fontSize={fontSize}
          fontFamily={fontFamily}
          x={x}
          y={y}
          onClick={cvcError ? () => {} : onClick}>
          ***
        </text>
      )}
      {isShowSecretInfo && !isLoadingCVC && (
        <text fill="#142633" fontWeight="bold" fontSize={fontSize} x={x} y={y}>
          {cvc}
        </text>
      )}
    </g>
  );
}
CVVValue.propTypes = {
  isShowSecretInfo: PropTypes.bool,
  isLoadingCVC: PropTypes.bool,
  cvc: PropTypes.string,
  onClick: PropTypes.func,
  cvcError: PropTypes.object,
};
export default CVVValue;
